import { SolicitacaoTecnicaService } from './../../../../services/solicitacao-tecnica.service';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { AuthService } from '../../../../services/auth.service';

export interface IAprovarModel {
  statusAvaliacao: number
}

@Component({
  selector: 'app-modal-avaliar-resposta',
  templateUrl: './modal-avaliar-resposta.component.html',
  styleUrls: ['./modal-avaliar-resposta.component.scss']
})
export class ModalAvaliarRespostaComponent implements OnInit {

  public submitted: boolean = false;
  public model: IAprovarModel = {} as IAprovarModel;
  public id: number;

  constructor(
    private dialogRef: MatDialogRef<ModalAvaliarRespostaComponent>,
    public service: SolicitacaoTecnicaService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.id = data?.id;
  }

  public form = new FormGroup({
    comentario: new FormControl("", Validators.required)
  });

  ngOnInit(): void {

    this.model.statusAvaliacao = 3;
    this.controlaStatusAvaliacao();
  }

  public salvar() {

    this.submitted = true;
    if (this.form.invalid) {
      return
    }

    const dados = {
      id: this.id,
      statusAvaliacao: this.model?.statusAvaliacao,
      responsavelIdAvaliacao: this.authService.usuario.id,
      comentarioAvaliacao: this.form.get('comentario')?.value
    } as any;

    this.service.avaliarItem(dados).then((res) => {
      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
        this.dialogRef.close();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    }).catch((err) => {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    })
  }

  public controlaStatusAvaliacao() {

    if (this.model.statusAvaliacao === 1) {
      this.form.get('comentario')?.clearValidators();
    }
    else {
      this.form.get('comentario')?.setValidators(Validators.required);
    }
    this.form.get('comentario')?.updateValueAndValidity();
  }

  public cancelar() {
    this.dialogRef.close();
  }

}
